import {
  ApiListResponse,
  RuleGroup,
  RuleGroupPatch,
  RuleGroupPost,
  RuleGroupType
} from "@gymflow/types";
import { AxiosInstance } from "axios";


export type RuleApiType = ReturnType<typeof ruleApi>;

const ruleApi = (axiosInstance: AxiosInstance, clubId: number) => {
  const clubPrefix = `club/${clubId}/`;
  return {
    ruleGroup(ruleGroupId: number) {
      return axiosInstance.get<RuleGroup>(
        `${clubPrefix}rule-group/${ruleGroupId}`,
      );
    },
    newRuleGroup(fields: RuleGroupPost) {
      return axiosInstance.post(`${clubPrefix}rule-group/`, fields);
    },
    editRuleGroup(ruleGroupId: number, patchedFields: RuleGroupPatch) {
      return axiosInstance.put(
        `${clubPrefix}rule-group/${ruleGroupId}`,
        patchedFields,
      );
    },
    ruleGroupSearch({
      isActive,
      isDefault,
      groupType,
      page,
      size,
    }: {
      isActive?: boolean;
      isDefault?: boolean;
      groupType?: RuleGroupType;
      page: number;
      size: number;
    }) {
      return axiosInstance.put<ApiListResponse<RuleGroup>>(
        `${clubPrefix}rule-group/search`,
        {
          isActive,
          isDefault,
          groupType,
          page,
          size,
        },
      );
    },
    ruleGroupDelete(ruleGroupId: number) {
      return axiosInstance.delete(`${clubPrefix}rule-group/${ruleGroupId}`);
    },
  };
};

export default ruleApi;
